import { useDispatch, useSelector } from "react-redux";
import { setTimeRange } from "../../redux/reducers/dataSlice";
import "./style.css";

export default function TimeRangeControl() {
  const dispatch = useDispatch();
  const timeRange = useSelector((state) => state.dataState.timeRange);
  const layers = useSelector((state) => state.dataState.layers);
  
  // Verificar si la capa de focos_historicos está visible
  const focosHistoricosLayer = layers.find(layer => layer.id === 'focosHistoricos');
  const isVisible = focosHistoricosLayer?.visible;

  // Si la capa no está visible, no mostrar el componente
  if (!isVisible) {
    return null;
  }

  const handleStartDateChange = (e) => {
    const newStartDate = parseInt(e.target.value);
    if (newStartDate <= timeRange.endDate) {
      dispatch(setTimeRange({ startDate: newStartDate, endDate: timeRange.endDate }));
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = parseInt(e.target.value);
    if (newEndDate >= timeRange.startDate) {
      dispatch(setTimeRange({ startDate: timeRange.startDate, endDate: newEndDate }));
    }
  };

  const formatDate = (day) => {
    return `${day} Ene`;
  };

  return (
    <div className="time-range-content">
        <div className="time-range-slider-group">
            <div className="time-range-slider-container">
            <label htmlFor="startDate" className="slider-label">
                Desde: <strong>{formatDate(timeRange.startDate)}</strong>
            </label>
            <input
                id="startDate"
                type="range"
                min="17"
                max="26"
                value={timeRange.startDate}
                onChange={handleStartDateChange}
                className="time-range-slider"
            />
            </div>

            <div className="time-range-slider-container">
            <label htmlFor="endDate" className="slider-label">
                Hasta: <strong>{formatDate(timeRange.endDate)}</strong>
            </label>
            <input
                id="endDate"
                type="range"
                min="17"
                max="26"
                value={timeRange.endDate}
                onChange={handleEndDateChange}
                className="time-range-slider"
            />
            </div>
        </div>

        <div className="time-range-summary">
            Mostrando focos del <strong>{formatDate(timeRange.startDate)}</strong> al <strong>{formatDate(timeRange.endDate)}</strong>
        </div>
    </div>
  );
}
